import { render, staticRenderFns } from "./MonitorShare.vue?vue&type=template&id=01677446"
import script from "./MonitorShare.vue?vue&type=script&lang=js"
export * from "./MonitorShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports